/* T8 Photo Framer — upload → live preview inside the scene's frame (drag / zoom / orientation), option pills,
   variant + price resolution, multipart add-to-cart, live order-cutoff countdown + delivery timeline.
   Ported from v6 assets/tamyra-frame.js. */
(function () {
  'use strict';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  var DEMO_BASE = [2679, 3399, 3899, 4499, 4999, 5499, 6499, 7999, 9999, 12999];

  function parseSize(s) {
    var m = /(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i.exec(s || '');
    return m ? { w: Number(m[1]), h: Number(m[2]) } : { w: 3, h: 4 };
  }
  /* same moulding as the PDP preview (t8-frame-preview.js): face colour + the four lit faces (top, left, right, bottom) */
  var COLOR = { black: '#26262a', white: '#f1efea', natural: '#cfb79c', brown: '#4a3630', silver: '#b0aaa2', rosegold: '#d8a48f', gold: '#a8844d' };
  var SIDES = {
    black: ['#3c3c41', '#313136', '#1c1c1f', '#141416'], white: ['#ffffff', '#f8f6f2', '#dfdbd4', '#d3cec6'],
    brown: ['#5f473f', '#553f38', '#3b2a25', '#2c1f1a'], natural: ['#e1cbb2', '#d9c2a8', '#bfa486', '#ad9479'],
    gold: ['#c9a666', '#b8955a', '#8f6f3d', '#7a5c30'], silver: ['#d6d2cc', '#c6c1ba', '#9c968e', '#8a847c'], rosegold: ['#e8b9a5', '#ddac97', '#c08f7a', '#ad7e6a']
  };
  function frameStyle(handle) {
    var h = (handle || '').toLowerCase();
    if (h.indexOf('rolled') !== -1 || h.indexOf('wrap') !== -1) return { none: true, color: 'transparent', thin: false };
    var thin = h.indexOf('metal') !== -1 || h.indexOf('floating') !== -1;
    // face colours sampled from the real frame photos (same palette as t8-frame-preview.js); floaters also show their gap colour
    var finish = 'black', gap = '#18171b';
    if (h.indexOf('white') !== -1) { finish = 'white'; gap = '#cfcdc9'; }
    else if (h.indexOf('natural') !== -1 || h.indexOf('wood') !== -1) { finish = 'natural'; gap = '#b39c82'; }
    else if (h.indexOf('brown') !== -1) { finish = 'brown'; gap = '#33241f'; }
    else if (h.indexOf('champagne') !== -1 || h.indexOf('silver') !== -1) { finish = 'silver'; gap = '#18171b'; }
    else if (h.indexOf('rose') !== -1) { finish = 'rosegold'; gap = '#18171b'; }
    else if (h.indexOf('gold') !== -1) { finish = 'gold'; gap = '#18171b'; }
    return { none: false, finish: finish, color: COLOR[finish], sides: SIDES[finish], thin: thin, floating: h.indexOf('float') !== -1, gap: gap };
  }
  function money(n) { return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function fmt(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }   // 23 Oct (same as the product page)
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }

  function init(root) {
    (root || document).querySelectorAll('[data-t8-pf]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var form = box.querySelector('[data-t8-pf-form]');
      var stage = box.querySelector('[data-t8-pf-stage]');
      var frame = box.querySelector('[data-t8-pf-frame]');
      var art = box.querySelector('[data-t8-pf-art]');
      var img = box.querySelector('[data-t8-pf-img]');
      var file = box.querySelector('[data-t8-pf-file]');
      var zoom = box.querySelector('[data-t8-pf-zoom]');
      var orientBtns = box.querySelectorAll('[data-t8-pf-orient]');
      var priceEl = box.querySelector('[data-t8-pf-price]');
      var frameName = box.querySelector('[data-t8-pf-frame-name]');
      var addBtn = box.querySelector('[data-t8-pf-add]');
      var msg = box.querySelector('[data-t8-pf-msg]');
      var hid = {
        variant: box.querySelector('[data-t8-pf-variant]'), qty: box.querySelector('[data-t8-pf-qty-input]'),
        orient: box.querySelector('[data-t8-pf-orient-input]'), mount: box.querySelector('[data-t8-pf-mount-input]'),
        crop: box.querySelector('[data-t8-pf-crop]'), dims: box.querySelector('[data-t8-pf-dims]')
      };
      var variants = null;
      var vs = box.querySelector('[data-t8-pf-variants]');
      if (vs) { try { variants = JSON.parse(vs.textContent); } catch (e) { variants = null; } }
      var order = (box.dataset.order || 'size,material,frame').split(',').filter(Boolean);
      var win = (box.dataset.window || '29.5,8.5,41,58').split(',').map(Number);
      var demo = !!box.dataset.demo;

      var state = { loaded: false, natW: 0, natH: 0, zoom: 1, x: 0, y: 0, orient: 'Portrait', size: '', material: '', frame: '', mount: 'No', qty: 1 };
      box.querySelectorAll('[data-t8-pf-opt].is-active').forEach(function (b) { state[b.dataset.t8PfOpt] = b.dataset.value; });
      stage.style.setProperty('--pf-win-l', win[0] + '%'); stage.style.setProperty('--pf-win-t', win[1] + '%');
      stage.style.setProperty('--pf-win-w', win[2] + '%'); stage.style.setProperty('--pf-win-h', win[3] + '%');

      /* ---------- variant / price ---------- */
      function variantKey() {
        return order.map(function (o) { return o === 'other' ? '' : state[o]; }).join(' / ');
      }
      function findVariant() {
        if (!variants) return null;
        var key = variantKey();
        if (variants[key]) return variants[key];
        // tolerate case / spacing differences
        var norm = key.replace(/\s+/g, '').toLowerCase();
        for (var k in variants) if (k.replace(/\s+/g, '').toLowerCase() === norm) return variants[k];
        return null;
      }
      function demoPrice() {
        var sizes = Array.prototype.map.call(box.querySelectorAll('[data-t8-pf-opt="size"]'), function (b) { return b.dataset.value; });
        var i = Math.max(0, sizes.indexOf(state.size));
        var base = DEMO_BASE[Math.min(i, DEMO_BASE.length - 1)];
        if (/canvas/i.test(state.material)) base = Math.round(base * 1.3);
        var fs = frameStyle(state.frame);
        if (!fs.none) base += fs.thin ? 900 : 700;
        return money(base);
      }
      /* price row, as on the product page: launch discount → ↓ % · struck-through full price · price */
      var discEl = box.querySelector('[data-t8-pf-disc]'), discText = box.querySelector('[data-t8-pf-disc-text]'), cmpEl = box.querySelector('[data-t8-pf-compare]');
      var launch = Number(box.dataset.launch) || 0, moneyFmt = box.dataset.money || 'Rs. {{amount}}';
      function fmtMoney(c) { return moneyFmt.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); }
      function paintPrice(v) {
        if (!v || typeof v.cents !== 'number') { if (v) priceEl.textContent = v.price; return; }
        var cp = v.cents, cc = v.cmp || 0;
        if (launch > 0 && cc <= cp) { cc = cp; cp = Math.floor((cp - Math.floor(cp * launch / 100)) / 100) * 100; }
        var pct = cc > cp ? Math.floor((cc - cp) * 100 / cc) : 0;
        priceEl.textContent = fmtMoney(cp);
        if (cmpEl) { cmpEl.hidden = !pct; cmpEl.textContent = fmtMoney(cc); }
        if (discEl) { discEl.hidden = !pct; if (discText) discText.textContent = pct + '%'; }
      }
      function syncPrice() {
        if (variants) {
          var v = findVariant();
          if (v) { paintPrice(v); hid.variant.value = v.id; addBtn.disabled = !v.available; var bb = box.querySelector('[data-t8-pf-buy]'); if (bb) bb.disabled = !v.available; if (!v.available) note('This combination is sold out.', 'error'); else note(''); }
          else {   /* a chart size the product has no variant for yet: made to order, confirmed on WhatsApp */
            priceEl.textContent = 'On request'; if (cmpEl) cmpEl.hidden = true; if (discEl) discEl.hidden = true; addBtn.disabled = false; note('This size is made to order. We will confirm the price on WhatsApp.');
          }
          setWa(!v && !!box.dataset.wa);
        } else if (demo) { priceEl.textContent = demoPrice(); }
        hid.mount.value = state.mount;
      }
      var atcLabel = addBtn ? addBtn.querySelector('span') : null, atcText = atcLabel ? atcLabel.textContent : '';
      function setWa(on) { box.classList.toggle('is-wa', on); if (atcLabel) atcLabel.textContent = on ? 'Order on WhatsApp' : atcText; }
      function note(text, kind) { if (!msg) return; msg.textContent = text || ''; msg.className = 't8-pf__msg' + (kind ? ' is-' + (kind === 'error' ? 'error' : 'ok') : ''); }

      /* ---------- option pills ---------- */
      box.querySelectorAll('[data-t8-pf-opt]').forEach(function (b) {
        b.addEventListener('click', function () {
          var opt = b.dataset.t8PfOpt;
          box.querySelectorAll('[data-t8-pf-opt="' + opt + '"]').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', String(on)); });
          state[opt] = b.dataset.value;
          if (opt === 'frame' && frameName) frameName.textContent = b.dataset.label || b.dataset.value;
          if (opt === 'material') { syncMount(); syncFloaters(); }
          if (opt === 'frame') syncMount();
          syncPrice(); applyFrame();
        });
      });
      // arrow keys inside a radiogroup
      box.querySelectorAll('[role="radiogroup"]').forEach(function (g) {
        g.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var items = Array.prototype.slice.call(g.querySelectorAll('[role="radio"]'));
          var i = items.indexOf(document.activeElement); if (i === -1) return;
          var n = items[(i + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length];
          e.preventDefault(); n.focus(); n.click();
        });
      });
      /* › buttons on the size pills and frame swatches: each scrolls the row just before it */
      box.querySelectorAll('[data-t8-pf-more]').forEach(function (more) {
        var sw = more.previousElementSibling; if (!sw) return;
        function moreState() {
          more.hidden = sw.scrollWidth - sw.clientWidth - sw.scrollLeft < 4;
          // centre the › on the size boxes / frame images (the row carries extra top padding for the badges)
          var o = [].find.call(sw.querySelectorAll('img, [role="radio"]:not(:has(img))'), function (e) { return e.offsetHeight; });
          if (o && o.offsetHeight) { var r = o.getBoundingClientRect(), w = more.parentNode.getBoundingClientRect(); more.style.top = (r.top - w.top + r.height / 2) + 'px'; }
        }
        sw.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', moreState, { once: true }); });
        more.addEventListener('click', function () { sw.scrollBy({ left: 200, behavior: 'smooth' }); });
        sw.addEventListener('scroll', moreState, { passive: true }); window.addEventListener('resize', moreState); moreState();
      });
      /* Mount is offered with prints only: Canvas hides it and sets "No"; other materials bring back the last choice */
      var mountBlock = box.querySelector('[data-t8-pf-mount-block]'), mountBefore = null;
      function setMount(v) {
        state.mount = v;
        box.querySelectorAll('[data-t8-pf-opt="mount"]').forEach(function (x) { var on = x.dataset.value === v; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', String(on)); });
      }
      function syncMount() {
        if (!mountBlock) return;
        var canvas = /canvas/i.test(state.material || '') || /rolled|wrap/i.test(state.frame || '');   // no mount on canvas, rolled art or gallery wrap
        if (canvas && !mountBlock.hidden) { mountBefore = state.mount; setMount('No'); }
        if (!canvas && mountBlock.hidden && mountBefore) { setMount(mountBefore); mountBefore = null; }
        mountBlock.hidden = canvas;
      }
      /* floater frames and Gallery Wrap are for canvas only, rolled art for prints only: the others hide, and a hidden pick moves to the first frame left */
      function syncFloaters() {
        var canvas = /canvas/i.test(state.material || ''), active = null;
        box.querySelectorAll('[data-t8-pf-opt="frame"]').forEach(function (x) {
          x.hidden = canvas ? /rolled/i.test(x.dataset.value || '') : /float|wrap/i.test(x.dataset.value || '');   // floaters + gallery wrap: canvas only; rolled art: prints only
          if (x.classList.contains('is-active')) active = x;
        });
        if (active && active.hidden) { var first = box.querySelector('[data-t8-pf-opt="frame"]:not([hidden])'); if (first) first.click(); }
        /* the row got shorter or longer: re-check its › (hidden when everything fits) */
        box.querySelectorAll('[data-t8-pf-more]').forEach(function (m) { if (m.previousElementSibling) m.previousElementSibling.dispatchEvent(new Event('scroll')); });
      }

      /* ---------- quantity ---------- */
      var qout = box.querySelector('[data-t8-pf-qty-out]');
      box.querySelectorAll('[data-t8-pf-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          state.qty = Math.max(1, Math.min(99, state.qty + Number(b.dataset.t8PfQty)));
          qout.textContent = state.qty; hid.qty.value = state.qty;
        });
      });

      /* ---------- frame geometry ---------- */
      function applyFrame() {
        var W = stage.clientWidth, H = stage.clientHeight; if (!W || !H) return;
        var cx = W / 2, cy = H / 2;
        var sz = parseSize(state.size), ratio = Math.max(sz.w, sz.h) / Math.min(sz.w, sz.h);
        /* the frame hangs centred on a plain wall at one fixed on-screen size: the longest side never changes with the
           chosen print size (only the proportions do), and both sides always stay inside the stage */
        var w, h;
        if (state.orient === 'Landscape') { w = Math.min(W * 0.68, H * 0.8); h = w / ratio; }
        else { h = H * 0.8; w = h / ratio; if (w > W * 0.8) { w = W * 0.8; h = w * ratio; } }
        var fs = frameStyle(state.frame);
        var side = Math.min(w, h);   // moulding and mount on the short side: as thick on a landscape frame as on a portrait one
        var border = fs.none ? 0 : Math.round(side * (fs.thin ? 0.018 : 0.047));   // wood moulding ~5.2% of the artwork's short side, as on Dessine Art
        var mount = !fs.none && state.mount === 'Yes';
        var mat = mount ? Math.round(side * 0.075) : (fs.floating ? Math.round(side * 0.012) : 0);   // floater: thin gap in its ledge colour
        frame.className = 't8-pf__frame is-style-' + (state.frame || 'rolled-art').toLowerCase().replace(/[^a-z0-9]+/g, '-') + (fs.finish ? ' is-finish-' + fs.finish : '') + (mount ? ' has-mount' : '');
        ['top', 'left', 'right', 'bottom'].forEach(function (k, n) { if (fs.sides) frame.style.setProperty('--pf-' + k, fs.sides[n]); else frame.style.removeProperty('--pf-' + k); });
        frame.style.left = ((cx - w / 2) / W * 100) + '%'; frame.style.top = ((cy - h / 2) / H * 100) + '%';
        frame.style.width = (w / W * 100) + '%'; frame.style.height = (h / H * 100) + '%';
        frame.style.setProperty('--pf-border', border + 'px'); frame.style.setProperty('--pf-color', fs.color);
        frame.style.setProperty('--pf-mat', mat + 'px'); frame.style.setProperty('--pf-matbg', mount ? '#fbfaf7' : (fs.floating ? fs.gap : 'transparent'));
        hid.orient.value = state.orient;
        requestAnimationFrame(function () { clampPan(); paint(); });
      }
      function coverScale() {
        var bw = art.clientWidth, bh = art.clientHeight;
        if (!bw || !bh || !state.natW) return 1;
        return Math.max(bw / state.natW, bh / state.natH);
      }
      function clampPan() {
        if (!state.loaded) return;
        var s = coverScale() * state.zoom, iw = state.natW * s, ih = state.natH * s;
        var maxX = Math.max(0, (iw - art.clientWidth) / 2), maxY = Math.max(0, (ih - art.clientHeight) / 2);
        state.x = Math.max(-maxX, Math.min(maxX, state.x)); state.y = Math.max(-maxY, Math.min(maxY, state.y));
      }
      function paint() {
        if (!state.loaded) return;
        var s = coverScale() * state.zoom;
        img.style.width = (state.natW * s) + 'px'; img.style.height = (state.natH * s) + 'px';
        img.style.transform = 'translate(calc(-50% + ' + state.x + 'px), calc(-50% + ' + state.y + 'px))';
        var bw = art.clientWidth || 1, bh = art.clientHeight || 1;
        hid.crop.value = 'zoom ' + state.zoom.toFixed(2) + ', offset ' + Math.round(100 * state.x / bw) + '% / ' + Math.round(100 * state.y / bh) + '%';
      }

      /* ---------- loading ---------- */
      function load(src, name) {
        var probe = new Image();
        probe.onload = function () {
          state.natW = probe.naturalWidth; state.natH = probe.naturalHeight; state.loaded = true;
          state.zoom = 1; state.x = 0; state.y = 0; if (zoom) zoom.value = 1;
          img.src = src;
          setOrient(state.natW > state.natH ? 'Landscape' : 'Portrait');
          box.classList.add('has-photo');
          hid.dims.value = state.natW + ' × ' + state.natH + ' px' + (name ? ' (' + name + ')' : '');
          note('');
          applyFrame();
          clampPan(); paint();   // size the photo to cover the frame immediately (don't rely on the next animation frame)
        };
        probe.onerror = function () { note('That file could not be read. Please use a JPG or PNG.', 'error'); };
        probe.src = src;
      }
      function fromFile(f) {
        if (!f) return;
        if (f.size > 20 * 1024 * 1024) { note('Please keep the photo under 20 MB.', 'error'); file.value = ''; return; }
        if (/heic|heif/i.test(f.type) || /\.hei[cf]$/i.test(f.name)) { box.classList.add('has-photo'); note('HEIC received — the preview is not available in this browser, but the file will be sent with your order.', 'ok'); return; }
        load(URL.createObjectURL(f), f.name);
      }
      file.addEventListener('change', function () { fromFile(file.files && file.files[0]); });
      ['dragenter', 'dragover'].forEach(function (ev) { stage.addEventListener(ev, function (e) { e.preventDefault(); box.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { stage.addEventListener(ev, function (e) { e.preventDefault(); box.classList.remove('is-drag'); }); });
      stage.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (!f) return;
        try { var dt = new DataTransfer(); dt.items.add(f); file.files = dt.files; } catch (err) {}
        fromFile(f);
      });
      var replace = box.querySelector('[data-t8-pf-replace]');
      if (replace) replace.addEventListener('click', function () { file.click(); });
      /* delete: back to the empty upload box */
      var del = box.querySelector('[data-t8-pf-delete]');
      if (del) del.addEventListener('click', function () {
        file.value = ''; state.loaded = false; state.zoom = 1; state.x = 0; state.y = 0; if (zoom) zoom.value = 1;
        img.removeAttribute('src'); img.removeAttribute('style');
        hid.dims.value = ''; hid.crop.value = '';
        box.classList.remove('has-photo'); note('');
      });

      /* ---------- pan / zoom / orientation ---------- */
      var dragging = null;
      art.addEventListener('pointerdown', function (e) { if (!state.loaded) return; dragging = { x: e.clientX - state.x, y: e.clientY - state.y }; art.setPointerCapture(e.pointerId); art.classList.add('is-dragging'); });
      art.addEventListener('pointermove', function (e) { if (!dragging) return; state.x = e.clientX - dragging.x; state.y = e.clientY - dragging.y; clampPan(); paint(); });
      ['pointerup', 'pointercancel'].forEach(function (ev) { art.addEventListener(ev, function () { dragging = null; art.classList.remove('is-dragging'); }); });
      if (zoom) zoom.addEventListener('input', function () { state.zoom = Number(zoom.value) || 1; clampPan(); paint(); });
      var orientSel = box.querySelector('[data-t8-pf-orient-select]');
      function setOrient(o) {
        state.orient = o;
        orientBtns.forEach(function (b) { var on = b.dataset.t8PfOrient === o; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
        if (orientSel && orientSel.value !== o) orientSel.value = o;
      }
      orientBtns.forEach(function (b) { b.addEventListener('click', function () { setOrient(b.dataset.t8PfOrient); applyFrame(); }); });
      if (orientSel) orientSel.addEventListener('change', function () { setOrient(orientSel.value); applyFrame(); });
      window.addEventListener('resize', function () { applyFrame(); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { clampPan(); paint(); }).observe(art);
      img.addEventListener('load', function () { clampPan(); paint(); });   // and again once the photo has decoded

      /* ---------- copy the offer code ---------- */
      box.querySelectorAll('[data-t8-pf-copy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var done = function () { btn.classList.add('is-copied'); setTimeout(function () { btn.classList.remove('is-copied'); }, 1600); };
          if (navigator.clipboard) navigator.clipboard.writeText(btn.dataset.t8PfCopy || '').then(done, done); else done();
        });
      });

      /* ---------- add to cart / buy now ---------- */
      var buyBtn = box.querySelector('[data-t8-pf-buy]'), buying = false;
      if (buyBtn) buyBtn.addEventListener('click', function () {
        buying = true;
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        buying = false;
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var now = buying;   // Buy Now: add, then checkout instead of the cart drawer
        if (box.classList.contains('is-wa')) {   /* size not in the catalogue yet: send the order to the studio on WhatsApp */
          var m = 'Hi! I would like to frame my photo: Size ' + state.size + (state.material ? ', ' + state.material : '') + (state.frame ? ', ' + state.frame : '') + (state.mount ? ', mount ' + state.mount : '') + '. I will share the photo here.';
          var wa = box.dataset.wa; window.open(wa + (wa.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(m), '_blank', 'noopener'); return;
        }
        if (!box.classList.contains('has-photo')) {
          note(box.dataset.missing || 'Please add a photo first.', 'error');
          box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake');
          file.focus(); return;
        }
        if (now && buyBtn) {
          var bl = buyBtn.querySelector('span'), bo = bl.textContent;
          buyBtn.disabled = addBtn.disabled = true; bl.textContent = 'Opening checkout…';
          if (demo || !variants) { setTimeout(function () { bl.textContent = bo; buyBtn.disabled = addBtn.disabled = false; }, 800); return; }
          fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Cart error'); return d; }); })
            .then(function () { window.location = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; })
            .catch(function (err) { bl.textContent = bo; buyBtn.disabled = addBtn.disabled = false; note(err.message || "Couldn't start checkout. Please try again.", 'error'); });
          return;
        }
        var label = addBtn.querySelector('span'), orig = label.textContent;
        addBtn.disabled = true; label.textContent = 'Adding…';
        var done = function () { label.textContent = 'Added ✓'; note(box.dataset.added || 'Added to your cart.', 'ok'); setTimeout(function () { label.textContent = orig; addBtn.disabled = false; }, 1500); };
        if (demo || !variants) { setTimeout(done, 500); return; }
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Cart error'); return d; }); })
          .then(function (added) {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
              document.dispatchEvent(new CustomEvent('tamyra:cart:updated', { detail: { cart: cart, added: added } }));
              if (window.TamyraCart && window.TamyraCart.open) window.TamyraCart.open();
            });
          })
          .then(done)
          .catch(function (err) { label.textContent = orig; addBtn.disabled = false; note(err.message || 'Could not add to cart.', 'error'); });
      });

      /* ---------- countdown + dates ---------- */
      var cd = box.querySelector('[data-t8-pf-countdown]');
      var cutoff = Number(box.dataset.cutoff || 14);
      var ship = (box.dataset.ship || '1,2').split(',').map(Number), deliver = (box.dataset.deliver || '3,5').split(',').map(Number);
      function cdText(secs) { var h = Math.floor(secs / 3600), m = Math.floor(secs % 3600 / 60), sc = secs % 60; return (h ? h + (h === 1 ? ' hr ' : ' hrs ') : '') + m + (m === 1 ? ' min ' : ' mins ') + sc + (sc === 1 ? ' sec' : ' secs'); }
      function tick() {
        var now = new Date(), c = new Date(now); c.setHours(cutoff, 0, 0, 0);
        if (c <= now) c = addDays(c, 1);
        var secs = Math.max(0, Math.floor((c - now) / 1000));
        if (cd) cd.textContent = cdText(secs);
        var base = now.getHours() >= cutoff ? addDays(now, 1) : now;
        var s = box.querySelector('[data-t8-pf-date="shipped"]'), d = box.querySelector('[data-t8-pf-date="delivered"]');
        if (s) s.textContent = fmt(addDays(base, ship[0])) + (ship[1] > ship[0] ? ' – ' + fmt(addDays(base, ship[1])) : '');
        if (d) d.textContent = fmt(addDays(base, deliver[0])) + (deliver[1] > deliver[0] ? ' – ' + fmt(addDays(base, deliver[1])) : '');
        var eta = box.querySelector('[data-t8-pf-eta]'), dd = addDays(base, deliver[1] > deliver[0] ? deliver[1] : deliver[0]);
        if (eta) eta.textContent = dd.toLocaleDateString('en-GB', { weekday: 'long' }) + ', ' + dd.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      }
      tick(); setInterval(tick, 1000);   // every second (the countdown shows seconds)

      syncMount(); syncFloaters(); syncPrice(); applyFrame();
      box.t8Load = function (url) { load(url, 'sample'); };   // for tests / demos
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
